import React, { useState, useEffect } from "react";
import {
  Paper,
  Button,
  Dialog,
  DialogContent,
  TextField,
  DialogActions,
  Grid,
  DialogTitle,
  CircularProgress,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import api from "../../components/services/api";
// import DialogForAPI from "../../Component/DialogForAPI.js";
// import FileUploadService from "../../Services/FileUploadService";
import { styled } from "@mui/material/styles";
import "./css/styles.css";

const drawerHeight = "100%";
const drawerwidth = "100%";
const useStyles = makeStyles((theme) => ({
  root: {
    height: drawerHeight,
    width: drawerwidth,
    marginTop: 20,
  },
  Padding: {
    paddingTop: "2%",
    paddingRight: "6%",
    paddingLeft: "6%",
    paddingBottom: "2%",
  },
}));
export default function ManagePermissions() {
  const classes = useStyles();
  const EmpId = localStorage.getItem("EmpId");
  const [MenuList, setMenuList] = useState([]);
  const [SubMenuList, setSubMenuList] = useState([]);
  const [SubMenuNo, setSubMenuNo] = useState("");
  const [MenuNo, setMenuNo] = useState("");
  const [ActionList, setActionList] = useState([]);
  const [Name, setName] = useState("");
  const [MenuID, setMenuID] = useState("");
  const [OpenEdit, setOpenEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [Status, setStatus] = useState("Y");
  const [message, setmessage] = useState("");
  const [openCancel, setOpenCancel] = useState(false);
  const [ActionNo, setActionNo] = useState("");
  const [Loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [openUp, setOpenUp] = useState(false);
  const [Num, setNum] = useState(null);

  const Input = styled("input")({
    display: "none",
  });

  const fetchMenuAll = async () => {
    try {
      const result = await api.get("api/menu/list");

      const _result = result.data;
      setMenuList(_result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const fetchActionMenu = async (m_no, sub_m_no) => {
    try {
      // const params = qs.stringify({
      //   ...(MenuNo && { MenuNo }),
      //   ...(SubMenuNo && { SubMenuNo }),
      // });
      const data = {
        menuNo: m_no,
        subMenuNo: sub_m_no,
      };

      const result = await api.post("api/actionmenu/list", data);
      const _result = result.data;
      setActionList(_result);
      // console.log(_result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const EditAndAddMenu = async (add) => {
    setLoading(true);
    // const body = { MenuNo: add === 1 ? null : MenuNo, MenuName: Name, Status };

    const body = {
      menuName: Name,
      createId: EmpId,
      status: 1,
    };
    try {
      await api.post("api/menu/create", body).then((res) => {
        if (res) {
          setOpen(true);
          // setmessage(res.data.message);
          setTimeout(() => {
            handleClose();
            setOpen(false);
          }, 500);
          fetchMenuAll();
        }
      });
    } catch (error) {
      console.log("error => ", error);
      setLoading(false);
    }
  };

  const EditAndAddSubMenu = async (add) => {
    setLoading(true);

    const body = {
      menuNo: MenuNo,
      subMenuName: Name,
      createId: EmpId,
      status: 1,
    };

    try {
      await api.post("api/submenu/create", body).then((res) => {
        if (res) {
          setOpen(true);
          setmessage(res.data.message);
          setTimeout(() => {
            handleClose();
            setOpen(false);
          }, 500);
          fetchSubmenuList(MenuNo);
        }
      });
    } catch (error) {
      console.log("error => ", error);
      setLoading(false);
    }
  };

  const EditAndAddAction = async (add) => {
    setLoading(true);

    const body = {
      menuNo: MenuNo,
      subMenuNo: SubMenuNo,

      actionName: Name,
      createId: EmpId,
      status: 1,
    };

    try {
      const result = await api
        .post("api/actionmenu/create", body)
        .then((res) => {
          if (res) {
            setOpen(true);
            setmessage(res.data.message);
            setTimeout(() => {
              handleClose();
              setOpen(false);
            }, 500);
            fetchActionMenu(MenuNo, SubMenuNo);
          }
        });
    } catch (error) {
      console.log("error => ", error);
      setLoading(false);
    }
  };

  const Download = async () => {
    try {
      const result = await api({
        url: "api/setting/menu/download",
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Menu_Excel.xlsx");
        document.body.appendChild(link);
        link.click();
      });
    } catch (error) {
      console.log("error => ", error);
    }
  };

  // const Upload = async () => {
  //   setLoading(true);

  //   try {
  //     const result = await FileUploadService.uploadExcelCatagoly(files).then(
  //       (res) => {
  //         if (res) {
  //           setOpen(true);
  //           setmessage(res.data.message);
  //           setTimeout(() => {
  //             handleClose();
  //             setOpen(false);
  //           }, 2000);
  //           fetchActionMenu();
  //         }
  //       }
  //     );
  //     console.log(result);
  //   } catch (error) {
  //     console.log("Could not upload the file!", error);
  //     setFiles([]);
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    fetchMenuAll();
  }, []);

  const handleClose = () => {
    setLoading(false);

    setOpen(false);
    setOpenEdit(false);
    setOpenCancel(false);
    setName("");
    setMenuNo("");
    setSubMenuNo("");
    setStatus("Y");
    setFiles([]);
    setOpenUp(false);
    setNum(null);
  };

  const handleCloseDialog = (props) => {
    setOpen(props);
  };

  const handleOpenEditMenu = (Data, add) => {
    if (add === 1) {
      setOpenEdit(true);
      setMenuNo(Data.MenuNo);
      setSubMenuNo(null);
      setNum(3);
    } else {
      setName(Data.MenuName);
      setOpenEdit(true);
      setMenuNo(Data.MenuNo);
      setNum(1);
      setMenuID(Data.MenuId);
    }
  };

  const handleOpenEditSubMenu = (Data) => {
    setMenuID(Data.SubMenuId);
    setName(Data.SubMenuName);
    setSubMenuNo(Data.SubMenuNo);
    setMenuNo(Data.MenuNo);
    setNum(4);
    setOpenEdit(true);
  };

  const handleSaveEdit = async () => {
    // const selectedMenu = MenuList.filter((x) => x.menuNo === MenuNo);

    // selectedMenu.forEach((x) => {
    //   x.menuName = Name;
    // });

    // setMenuList([...MenuList]);

    // EditAndAddMenu();

    const data = {
      id: MenuID,
      menuName: Name,
      ModId: EmpId,
      status: 1,
    };

    try {
      const result = await api.post("api/menu/update", data).then((res) => {
        if (res) {
          setOpenEdit(true);
          // setmessage(res.data.message);
          setTimeout(() => {
            handleClose();
            setOpenEdit(false);
          }, 500);
          fetchMenuAll();
        }
      });
      // console.log(result);
    } catch (error) {
      console.log("error => ", error);
      setLoading(false);
    }
  };

  const handleSaveEditSub = async () => {
    // const selectedSubMenu = MenuList.find(
    //   (x) => x.menuNo === MenuNo
    // )?.subMenu.filter((x) => x.subMenuNo === SubMenuNo);

    // selectedSubMenu.forEach((x) => {
    //   x.subMenuName = Name;
    // });

    // setMenuList([...MenuList]);

    // EditAndAddSubMenu();
    const data = {
      id: MenuID,
      menuNo: MenuNo,
      subMenuName: Name,
      ModId: EmpId,
      status: 1,
    };
    // console.log(data);

    try {
      const result = await api.post("api/submenu/update", data).then((res) => {
        if (res) {
          setOpenEdit(true);
          setTimeout(() => {
            handleClose();
            setOpenEdit(false);
          }, 500);
          fetchSubmenuList(MenuNo);
        }
      });
      // console.log(result);
    } catch (error) {
      console.log("error => ", error);
      setLoading(false);
    }
  };

  const DeleteCategory = async () => {
    const data = {
      id: MenuID,

      ModId: EmpId,
    };
    // console.log(data);

    try {
      const result = await api.post("api/menu/delete", data).then((res) => {
        if (res) {
          setOpenCancel(true);
          setTimeout(() => {
            handleClose();
            setOpenCancel(false);
          }, 500);
          fetchMenuAll();
        }
      });
      // console.log(result);
    } catch (error) {
      console.log("error => ", error);
      setLoading(false);
    }
  };
  const DeleteSubmenu = async () => {
    const data = {
      id: MenuID,
      ModId: EmpId,
    };
    try {
      const result = await api.post("api/submenu/delete", data).then((res) => {
        if (res) {
          setOpenCancel(true);
          setTimeout(() => {
            handleClose();
            setOpenCancel(false);
          }, 500);
          fetchSubmenuList(MenuNo);
        }
      });
    } catch (error) {
      console.log("error => ", error);
      setLoading(false);
    }
  };

  const DeleteActionMenu = async () => {
    const data = {
      id: MenuID,
      ModId: EmpId,
    };

    try {
      const result = await api
        .post("api/actionmenu/delete", data)
        .then((res) => {
          if (res) {
            setOpenCancel(true);
            setTimeout(() => {
              handleClose();
              setOpenCancel(false);
            }, 500);
            fetchActionMenu(MenuNo, SubMenuNo);
          }
        });
    } catch (error) {
      console.log("error => ", error);
      setLoading(false);
    }
  };

  const handleSaveEditAction = async () => {
    const data = {
      id: MenuID,
      menuNo: MenuNo,
      subMenuNo: SubMenuNo,
      actionName: Name,
      ModId: EmpId,
      status: 1,
    };
    try {
      const result = await api
        .post("api/actionmenu/update", data)
        .then((res) => {
          if (res) {
            setOpenEdit(true);
            setTimeout(() => {
              handleClose();
              setOpenEdit(false);
            }, 500);
            fetchActionMenu(MenuNo, SubMenuNo);
          }
        });
    } catch (error) {
      console.log("error => ", error);
      setLoading(false);
    }
   
  };

  const handleCancelMenu = (MenuSelect) => {
    setName(MenuSelect.MenuName);
    setMenuNo(MenuSelect.MenuNo);
    setMenuID(MenuSelect.MenuId);
    setNum(2);

    setOpenCancel(true);
  };

  const handleCancelSubMenu = (SubSelect) => {
    setName(SubSelect.SubMenuName);
    setSubMenuNo(SubSelect.SubMenuNo);
    setMenuNo(SubSelect.MenuNo);
    setMenuID(SubSelect.SubMenuId);
    // setStatus("N");
    setNum(5);

    setOpenCancel(true);
  };

  const handleCancelAction = (ActionSelect) => {
    setMenuID(ActionSelect.ActionId);
    setMenuNo(ActionSelect.MenuNo);
    setSubMenuNo(ActionSelect.SubMenuNo);
    setActionNo(ActionSelect.ActionNo);
    setNum(8);

    setOpenCancel(true);
  };

  const handleSaveAddMenu = () => {
    setMenuNo(null);
    setOpenEdit(true);
    setNum(0);
  };

  const handleEditAndAddAction = (Data, add) => {
    if (add === 1) {
      setMenuNo(Data.MenuNo);
      setSubMenuNo(Data.SubMenuNo);
      setActionNo(null);
      setOpenEdit(true);
      setNum(6);
    } else {
      setMenuNo(Data.MenuNo);
      setSubMenuNo(Data.SubMenuNo);
      setName(Data.ActionName);
      setActionNo(Data.ActionNo);
      setMenuID(Data.ActionId);
      setNum(7);
      setOpenEdit(true);
    }
  };

  const handleFileUpload = (event) => {
    let currentFiles = event.target.files[0];

    setFile(currentFiles);

    event.target.value = null;
  };

  const setFile = (file) => {
    setFiles([...files, file]);
    setOpenUp(true);
  };

  const handleClickSubForAction = (Data) => {
    setMenuNo(Data.MenuNo);
    setSubMenuNo(Data.SubMenuNo);
    fetchActionMenu(Data.MenuNo, Data.SubMenuNo);
  };

  const fetchSubmenuList = async (Data) => {
    setMenuNo(Data.MenuNo);
    setSubMenuNo(Data.SubMenuNo);
    const data = {
      menuNo: Data,
    };

    try {
      const result = await api.post("api/submenu/list", data);
      const _result = result.data;
      setSubMenuList(_result);
      fetchActionMenu();
    } catch (error) {
      console.log("error => ", error);
    }
  };

  return (
    <div className={classes.root}>
      <Paper elevation={1} style={{ height: "88vh", overflow: "auto" }}>
        <div className={classes.Padding}>
          <p style={{ color: "#80C340", fontSize: 18 }}>Sritrang-Admin</p>
          <h3>จัดการสิทธิ์</h3>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: "row",
              marginBottom: 30,
              position: "sticky",
              top: 10,
            }}
          >
            {/* <Button
              variant="contained"
              size="large"
              style={{
                color: "#30318D",
                backgroundColor: "white",
                borderColor: "red",
                width: 120,
                textTransform: "none",
                whiteSpace: "nowrap",
              }}
              onClick={() => handleSaveAddMenu()}
            >
              Add Category
            </Button> */}
            {/* <Button
              variant="contained"
              size="large"
              style={{
                color: "#30318D",
                backgroundColor: "white",
                marginLeft: 10,
                borderColor: "#80C340",
                width: 120,
                textTransform: "lowercase",
              }}
              onClick={() => Download()}
            >
              Download
            </Button>
            <label htmlFor="contained-button-file">
              <Input
                accept="xlsx/*"
                id="contained-button-file"
                multiple
                type="file"
                onChange={handleFileUpload}
              />
              <Button
                variant="contained"
                size="large"
                style={{
                  color: "white",
                  backgroundColor: "#80C340",
                  borderColor: "transparent",
                  marginLeft: 10,
                  width: 120,
                  textTransform: "lowercase",
                }}
                component="span"
              >
                Upload
              </Button>
            </label> */}
          </div>

          <Grid container spacing={5} xs={12} lg={8}>
            <Grid item xs={6}>
              <p style={{ color: "#30318D" }}>Category</p>
              <div sx={{ maxHeight: "58vh", height: "58vh" }}>
              
                <table style={{ width: "100%", maxWidth: "100%" }}>
                  {MenuList.map((Data, index) => (
                    <tr key={Data.MenuId}>
                      <td
                        className="table-list-group-item-action"
                        style={{
                          display: "flex",
                          border: "1px solid #ffffff",
                          backgroundColor: "#E9E9E9",
                          borderRadius: "5px",
                          flexWrap: "wrap",
                        }}
                        onClick={() => {
                          fetchSubmenuList(Data.MenuNo);
                          setMenuNo(Data.MenuNo);
                          setSubMenuNo("");
                          // setActionList([...[]], ActionList);
                        }}
                      >
                        <span
                          style={{
                            margin: "5px 0px 5px 5px",
                          }}
                        >
                          {Data.MenuName}
                        </span>
                        <div
                          style={{
                            justifyContent: "flex-end",
                            display: "flex",
                            flexGrow: 1,
                          }}
                        >
                          {/* <button
                            style={{
                              border: 0,
                              backgroundColor: "transparent",
                            }}
                          >
                            <span
                              className="material-icons"
                              onClick={() => handleOpenEditMenu(Data)}
                            >
                              edit
                            </span>
                          </button> */}
                          {/* <button
                            style={{
                              border: 0,
                              backgroundColor: "transparent",
                            }}
                          >
                            <span
                              className="material-icons-outlined"
                              style={{
                                color: "#2DCE98",
                              }}
                              onClick={() => handleOpenEditMenu(Data, 1)}
                            >
                              add
                            </span>
                          </button> */}
                          {/* <button
                            style={{
                              border: 0,
                              backgroundColor: "transparent",
                            }}
                          >
                            <span
                              className="material-icons-outlined"
                              style={{ color: "#FF0000" }}
                              onClick={() => handleCancelMenu(Data)}
                            >
                              close
                            </span>
                          </button> */}
                        </div>
                      </td>
                      {SubMenuList.filter((x) => x.MenuNo === Data.MenuNo).map(
                        (sub) => (
                          <td
                            className="table-list-group-item-action"
                            style={
                              sub.SubMenuNo === SubMenuNo
                                ? {
                                  display: "flex",
                                  border: "1px solid #e0e0e0",
                                  backgroundColor: "#e7e7e7",
                                  borderRadius: "5px",
                                }
                                : {
                                  display: "flex",
                                  border: "1px solid #e0e0e0",
                                  // backgroundColor: "#FAFBFD",
                                  borderRadius: "5px",
                                }
                            }
                            onClick={() => handleClickSubForAction(sub)}
                          >
                            <span style={{ margin: "5px 0px 5px 20px" }}>
                              {sub.SubMenuName}
                            </span>
                            <div
                              style={{
                                justifyContent: "flex-end",
                                display: "flex",
                                flexGrow: 1,
                              }}
                            >
                              {/* <button
                                style={{
                                  border: 0,
                                  backgroundColor: "transparent",
                                }}
                              >
                                <span
                                  className="material-icons"
                                  onClick={() => handleOpenEditSubMenu(sub)}
                                >
                                  edit
                                </span>
                              </button> */}
                              {/* <button
                                style={{
                                  border: 0,
                                  backgroundColor: "transparent",
                                }}
                              >
                                <span
                                  className="material-icons-outlined"
                                  style={{
                                    color: "#2DCE98",
                                  }}
                                  onClick={() => handleEditAndAddAction(sub, 1)}
                                >
                                  add
                                </span>
                              </button> */}
                              {/* <button
                                style={{
                                  border: 0,
                                  backgroundColor: "transparent",
                                }}
                              >
                                <span
                                  className="material-icons-outlined"
                                  style={{ color: "#FF0000" }}
                                  onClick={() => handleCancelSubMenu(sub)}
                                >
                                  close
                                </span>
                              </button> */}
                            </div>
                          </td>
                        )
                      )}
                    </tr>
                  ))}
                </table>
              </div>
            </Grid>

            <Grid item xs={6}>
              <p style={{ color: "#30318D" }}>Action</p>
              <div sx={{ maxHeight: "58vh", height: "58vh" }}>
                <table style={{ width: "100%", maxWidth: "100%" }}>
                  {ActionList?.map((Data, index) => (
                    <tr key={Data.ActionId}>
                      <td
                        style={{
                          display: "flex",
                          border: "1px solid #e0e0e0",
                          borderRadius: "5px",
                          flexWrap: "wrap",
                        }}
                        onClick={() => setActionNo(Data.ActionNo)}
                      >
                        <span
                          style={{
                            margin: "5px 0px 5px 5px",
                          }}
                        >
                          [{Data.ActionNo}]<span>&nbsp;</span>
                          {Data.ActionName}
                        </span>
                        <div
                          style={{
                            justifyContent: "flex-end",
                            display: "flex",
                            flexGrow: 1,
                          }}
                        >
                          {/* <button
                            style={{
                              border: 0,
                              backgroundColor: "transparent",
                            }}
                          >
                            <span
                              className="material-icons"
                              onClick={() => handleEditAndAddAction(Data)}
                            >
                              edit
                            </span>
                          </button> */}
                          {/* <button
                            style={{
                              border: 0,
                              backgroundColor: "transparent",
                            }}
                          >
                            <span
                              className="material-icons-outlined"
                              style={{ color: "#FF0000" }}
                              onClick={() => handleCancelAction(Data)}
                            >
                              close
                            </span>
                          </button> */}
                        </div>
                      </td>
                    </tr>
                  ))}
                </table>
              </div>
            </Grid>
          </Grid>

          <Dialog
            open={OpenEdit}
            onClose={() => handleClose()}
            fullWidth={true}
            maxWidth="xs"
            classes={{ paper: classes.dialogPaper }}
          >
            <DialogContent>
              <TextField
                sx={{ width: "100%" }}
                size="small"
                onChange={(e) => setName(e.target.value)}
                value={Name}
                required
                // error={ExcelNameErr}
                label="ชื่อ"
              />
            </DialogContent>
            <DialogActions
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 20,
              }}
            >
              <Button
                variant="contained"
                style={{
                  color: "black",
                  borderColor: "transparent",
                  backgroundColor: "#F8F9FA",
                  padding: 10,
                  marginRight: 10,
                  width: 80,
                }}
                onClick={() => handleClose()}
              >
                ยกเลิก
              </Button>

              <Button
                variant="contained"
                style={{
                  color: "white",
                  backgroundColor: "#80C340",
                  borderColor: "transparent",
                  padding: 10,
                  marginRight: 10,
                  width: 80,
                }}
                onClick={
                  Num === 0
                    ? () => EditAndAddMenu(1)
                    : Num === 1
                      ? () => handleSaveEdit()
                      : Num === 3
                        ? () => EditAndAddSubMenu(1)
                        : Num === 4
                          ? () => handleSaveEditSub()
                          : Num === 6
                            ? () => EditAndAddAction(1)
                            : Num === 7
                              ? () => handleSaveEditAction()
                              : null
                }
              >
                {Loading ? (
                  <CircularProgress
                    sx={{
                      color: "#FFFFFF",
                    }}
                    size={24}
                  />
                ) : (
                  "ตกลง"
                )}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openCancel}
            onClose={() => handleClose()}
            fullWidth={true}
            maxWidth="xs"
            classes={{ paper: classes.dialogPaper }}
          >
            <DialogTitle>ยืนยันที่จะลบหรือไม่</DialogTitle>
            <DialogActions
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 20,
              }}
            >
              <Button
                variant="contained"
                style={{
                  color: "black",
                  borderColor: "transparent",
                  backgroundColor: "#F8F9FA",
                  padding: 10,
                  marginRight: 10,
                  width: 80,
                }}
                onClick={() => handleClose()}
              >
                ยกเลิก
              </Button>
              <Button
                variant="contained"
                style={{
                  color: "white",
                  backgroundColor: "#FF0000",
                  borderColor: "transparent",
                  padding: 10,
                  marginRight: 10,
                  width: 80,
                }}
                onClick={
                  Num === 2
                    ? () => DeleteCategory()
                    : Num === 5
                      ? () => DeleteSubmenu()
                      : Num === 8
                        ? () => DeleteActionMenu()
                        : null
                }
              >
                {Loading ? (
                  <CircularProgress
                    sx={{
                      color: "#FFFFFF",
                    }}
                    size={24}
                  />
                ) : (
                  "ตกลง"
                )}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openUp}
            onClose={handleClose}
            fullWidth={true}
            maxWidth="xs"
          >
            <DialogContent>
              {/* <p>{messageErr}</p> */}
              {files?.map((x, index) => {
                return (
                  <p>
                    {index + 1 + "." + " "}
                    {x.name}
                  </p>
                );
              })}
            </DialogContent>
            <DialogActions
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 20,
                marginTop: 20,
              }}
            >
              <Button
                variant="contained"
                style={{
                  color: "black",
                  borderColor: "transparent",
                  backgroundColor: "#F8F9FA",
                  width: 80,
                }}
                onClick={handleClose}
              >
                ปิด
              </Button>

              <Button
                variant="contained"
                style={{
                  color: "white",
                  backgroundColor: "#FF0000",
                  borderColor: "transparent",
                  marginRight: 10,
                  width: 80,
                }}
              // onClick={() => Upload()}
              >
                {Loading ? (
                  <CircularProgress
                    sx={{
                      color: "white",
                    }}
                    size={24}
                  />
                ) : (
                  "ตกลง"
                )}
              </Button>
            </DialogActions>
          </Dialog>

          {/* <DialogForAPI
            DialogOpen={open}
            DialogClose={handleCloseDialog}
            message={message}
          /> */}
        </div>
      </Paper>
    </div>
  );
}
